import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getExportReportHostTasks = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `host-task-report/tasks/details/export?${queries}`, responseType: 'blob' });

  return data;
};

export default getExportReportHostTasks;
